import React from 'react'
import { Glyphicon } from 'react-bootstrap'

import { printMoney } from '../../lib/Tools'
import { getText } from '../lib/text.js'

type Props = {
  price: Object, 
  trip: Object, 
}

const PriceTag = ({ price, trip }: Props) => (
  <span>
    {getText("Precio")} <small>(<Glyphicon glyph="star" />)</small>{": "}
    <strong><strong>{printMoney(price.finalE)}€ ó ￥{printMoney(price.finalY)}元</strong></strong>
    { 
      !trip.useForcedPrice 
        ? "" 
        : (
          <small style={{ marginLeft: 10 }}>
            (con el {trip.pGestion}% deberían ser {printMoney(price.calculatedFinalE, false)}€)
          </small>
        )
    }
  </span>
)

export default PriceTag
